import type { MeResponse } from '../types/api'

type RawMePayload = {
  user?: MeResponse['user']
  role?: MeResponse['role']
  permissions?: string[]
}

export function normalizeMeResponse(payload: RawMePayload): MeResponse {
  const user = payload.user
  if (!user?.user_id) {
    throw new Error('invalid_me_response')
  }

  return {
    user,
    role: payload.role ?? null,
    permissions: payload.permissions ?? payload.role?.permissions ?? [],
  }
}
